import { IChip } from "app/ComponentLibrary/Filter/ChipsContainer";
import { ISelection } from "app/ComponentLibrary/Filter/CustomSelect";
import i18next from "i18next";

export const enum ChangeOptionsEnum {
  PayCycle = 'Pay Cycle',
  FacilityID = 'Facility ID',
  OrderID = 'Order ID',
  PreStart = 'Pre-Start',
}

export const placementChangeOptions = 
   [
    {
      ID: 1,
      Description: ChangeOptionsEnum.PayCycle,
    },
    {
      ID: 2,
      Description: ChangeOptionsEnum.FacilityID,
    },
    {
      ID: 3,
      Description: ChangeOptionsEnum.OrderID,
    },
    {
      ID: 4,
      Description: ChangeOptionsEnum.PreStart,
    },
  ];

  
export interface IPlacementChangeOrderChips {
  orderIds: IChip[] ;
  facilityIds: IChip[] ;
  divisionIds: IChip[] ;
  disciplineIds: IChip[] ;
  specialtyIds: IChip[] ;
  subSpecialtyIds: IChip[];
  facilityStatusIds: IChip[];
  orderTypeIds: IChip[];
  orderPriorityIds: IChip[];
  orderStartDateRange: Date;
  dateEnteredRange: any | null;
  endDateRange: any | null;
  positions: any | null;
  states: IChip[] ;
  city: IChip[] ;
  paysGww: any | null;
  maxFilesSentId: any | null;
  shiftIds: IChip[];
  amUserIds: IChip[];
}
export const initialFilterOrderChips: IPlacementChangeOrderChips = {
  orderIds: [],
  facilityIds: [],
  divisionIds: [],
  disciplineIds: [],
  specialtyIds: [],
  subSpecialtyIds: [],
  facilityStatusIds: [],
  orderTypeIds: [],
  orderPriorityIds: [],
  orderStartDateRange: null,
  dateEnteredRange: null,
  endDateRange: null,
  positions: null,
  states: [],
  city: [],
  paysGww: null,
  maxFilesSentId: null,
  shiftIds: [],
  amUserIds: [],
};

interface IPlacementChangeFacilityChips {
  facilityIds: IChip[] ;
  divisionIds: IChip[] ;
  facilityStatusIds: IChip[];
  positions: any | null;
  states: IChip[] ;
  city: IChip[] ;
  amUserIds: IChip[];
}
export const initialFacilityChips: IPlacementChangeFacilityChips = {
  facilityIds: [],
  divisionIds: [],
  facilityStatusIds: [],
  positions: null,
  states: [],
  city: [],
  amUserIds: [],
};


  export const MFSOpts = [
    { id: 0, value: 1, name: 'Yes', labelPrefix: 'MFS' },
    { id: 1, value: 2, name: 'No', labelPrefix: 'MFS' },
  ];
  export const PaysGwwOpts = [
    { id: 0, value: 1, name: 'Yes', labelPrefix: 'GWW' },
    { id: 1, value: 2, name: 'No', labelPrefix: 'GWW' },
  ];
  
  export const positionOpts = [
    {
      id: 0,
      value: { min: 0, max: 0 },
      name: '0',
      labelPrefix: i18next.t('search.globalSearch.order.filterNames.positions'),
    },
    {
      id: 1,
      value: { min: 1, max: 999 },
      name: '>0',
      labelPrefix: i18next.t('search.globalSearch.order.filterNames.positions'),
    },
    {
      id: 2,
      value: { min: 1, max: 10 },
      name: '1-10',
      labelPrefix: i18next.t('search.globalSearch.order.filterNames.positions'),
    },
    {
      id: 3,
      value: { min: 10, max: 50 },
      name: '10-50',
      labelPrefix: i18next.t('search.globalSearch.order.filterNames.positions'),
    },
    {
      id: 4,
      value: { min: 50, max: 99 },
      name: '50-99',
      labelPrefix: i18next.t('search.globalSearch.order.filterNames.positions'),
    },
    
  ] as unknown as ISelection[];
